module.exports = __webpack_public_path__ + "view/img/logo(2).b268def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo(2).png
// module id = UV/d
// module chunks = 11